import {
  authentication,
  createDirectus,
  graphql,
  isDirectusError,
  rest,
} from "@directus/sdk";
import { Schema } from "./schema";

// Get environment variables
const directusUrl = import.meta.env.VITE_GRAPHQL_ENDPOINT;

if (!directusUrl) {
  throw new Error("VITE_GRAPHQL_ENDPOINT is required in environment variables");
}

export function createDirectusClient() {
  return createDirectus<Schema>(directusUrl)
    .with(rest())
    .with(graphql())
    .with(authentication("json"));
}

// Create Directus client with REST, GraphQL and authentication support
const directusClient = createDirectusClient();

export type GaripalliDirectusClient = typeof directusClient;

export default directusClient;

export function isTokenExpired(error: any): boolean {
  return (
    (error?.status === 401 || error?.response?.status === 401) &&
    error?.message?.includes("Token expired")
  );
}

export function isRefreshTokenResponseError(error: any): boolean {
  if (isDirectusError(error)) {
    const url = error.response?.url || "";
    return url.includes("/auth/refresh");
  }

  return false;
}
